"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var l10n_1 = __importDefault(require("@paprika/l10n"));
var SkipButton_1 = __importDefault(require("./components/SkipButton/SkipButton"));
var ThemeProvider_1 = __importDefault(require("./components/theme/ThemeProvider"));
var constants_1 = require("./constants");
var sc = __importStar(require("./GlobalNavigation.styles"));
var locales_1 = __importDefault(require("../locales"));
var components_1 = require("./components");
Object.defineProperty(exports, "AppSwitcherSidePanel", { enumerable: true, get: function () { return components_1.AppSwitcherSidePanel; } });
Object.defineProperty(exports, "CurrentApp", { enumerable: true, get: function () { return components_1.CurrentApp; } });
Object.defineProperty(exports, "Helper", { enumerable: true, get: function () { return components_1.Helper; } });
Object.defineProperty(exports, "HelperWithPendo", { enumerable: true, get: function () { return components_1.HelperWithPendo; } });
Object.defineProperty(exports, "LaunchpadLink", { enumerable: true, get: function () { return components_1.LaunchpadLink; } });
Object.defineProperty(exports, "Logo", { enumerable: true, get: function () { return components_1.Logo; } });
Object.defineProperty(exports, "User", { enumerable: true, get: function () { return components_1.User; } });
Object.defineProperty(exports, "SignIn", { enumerable: true, get: function () { return components_1.SignIn; } });
Object.defineProperty(exports, "OrgSwitcher", { enumerable: true, get: function () { return components_1.OrgSwitcher; } });
Object.defineProperty(exports, "KeyboardShortcutPanel", { enumerable: true, get: function () { return components_1.KeyboardShortcutPanel; } });
var KeyboardShortcutPanel_1 = require("./components/KeyboardShortcutPanel/KeyboardShortcutPanel");
Object.defineProperty(exports, "KeyboardShortcutPanelWithL10n", { enumerable: true, get: function () { return KeyboardShortcutPanel_1.KeyboardShortcutPanelWithL10n; } });
var appSwitcherPropsShape_1 = require("./components/AppSwitcherSidePanel/appSwitcherPropsShape");
Object.defineProperty(exports, "appSwitcherPropsShape", { enumerable: true, get: function () { return appSwitcherPropsShape_1.default; } });
var useShortcutPanel_1 = require("./components/KeyboardShortcutPanel/hooks/useShortcutPanel");
Object.defineProperty(exports, "useShortcutPanel", { enumerable: true, get: function () { return useShortcutPanel_1.default; } });
var data_1 = require("./data");
Object.defineProperty(exports, "appData", { enumerable: true, get: function () { return data_1.appData; } });
Object.defineProperty(exports, "resourceData", { enumerable: true, get: function () { return data_1.resourceData; } });
function GlobalNavigation(_a) {
    var children = _a.children, currentOrgSubscriptionType = _a.currentOrgSubscriptionType, isDiligentBrand = _a.isDiligentBrand, hasOrgNameOnTop = _a.hasOrgNameOnTop, locale = _a.locale, mainContentSelector = _a.mainContentSelector, zIndex = _a.zIndex;
    var isTrainingOrg = currentOrgSubscriptionType === 'training';
    function augmentedSubComponent(subComponent) {
        return subComponent ? react_1.default.cloneElement(subComponent, { key: subComponent.type.componentType, zIndex: zIndex }) : null;
    }
    function renderSubComponents(children, subComponentsList) {
        var subComponents = {};
        subComponents[constants_1.navigationItems.currentApp] = null;
        subComponents[constants_1.navigationItems.appSwitcher] = null;
        subComponents[constants_1.navigationItems.signIn] = null;
        subComponents[constants_1.navigationItems.helper] = null;
        subComponents[constants_1.navigationItems.helperWithPendo] = null;
        subComponents[constants_1.navigationItems.logo] = null;
        subComponents[constants_1.navigationItems.user] = null;
        subComponents[constants_1.navigationItems.keyboardShortcutPanel] = null;
        react_1.default.Children.forEach(children, function (child) {
            if (child.type && subComponentsList.includes(child.type.componentType)) {
                subComponents[child.type.componentType] = child;
            }
        });
        var commonSubComponents = [
            augmentedSubComponent(subComponents[constants_1.navigationItems.signIn]),
            augmentedSubComponent(subComponents[constants_1.navigationItems.keyboardShortcutPanel]),
            augmentedSubComponent(subComponents[constants_1.navigationItems.helper]),
            augmentedSubComponent(subComponents[constants_1.navigationItems.helperWithPendo]),
            augmentedSubComponent(subComponents[constants_1.navigationItems.user]),
        ];
        if (hasOrgNameOnTop) {
            return __spreadArrays([
                augmentedSubComponent(subComponents[constants_1.navigationItems.appSwitcher]),
                augmentedSubComponent(subComponents[constants_1.navigationItems.launchpadLink])
            ], commonSubComponents);
        }
        return __spreadArrays([
            augmentedSubComponent(subComponents[constants_1.navigationItems.logo]),
            augmentedSubComponent(subComponents[constants_1.navigationItems.appSwitcher]),
            augmentedSubComponent(subComponents[constants_1.navigationItems.currentApp])
        ], commonSubComponents);
    }
    return (react_1.default.createElement(l10n_1.default, { locale: locale, locales: locales_1.default },
        react_1.default.createElement(ThemeProvider_1.default, { isDiligentBrand: isDiligentBrand, isTrainingOrg: isTrainingOrg, hasOrgNameOnTop: hasOrgNameOnTop },
            mainContentSelector ? react_1.default.createElement(SkipButton_1.default, { mainContentSelector: mainContentSelector }) : null,
            react_1.default.createElement(sc.GlobalNavigationWrapper, { "data-sri-anchor": "global-navigation" },
                react_1.default.createElement(sc.NavigationLeft, { "data-sri-anchor": "navigation-left" }, renderSubComponents(children, constants_1.leftNavigationItems)),
                renderSubComponents(children, constants_1.rightNavigationItems)))));
}
GlobalNavigation.propTypes = {
    children: prop_types_1.default.node,
    currentOrgSubscriptionType: prop_types_1.default.string,
    isDiligentBrand: prop_types_1.default.bool,
    hasOrgNameOnTop: prop_types_1.default.bool,
    locale: prop_types_1.default.string,
    mainContentSelector: prop_types_1.default.string,
    zIndex: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
};
GlobalNavigation.defaultProps = {
    children: null,
    currentOrgSubscriptionType: null,
    isDiligentBrand: null,
    hasOrgNameOnTop: null,
    locale: 'en',
    mainContentSelector: null,
    zIndex: null,
};
exports.default = GlobalNavigation;
//# sourceMappingURL=GlobalNavigation.js.map